module.exports = __webpack_public_path__ + "media/img/pages/companies/migros-gruppe-50342c47156c1746caf10bc9cec67c9c.png";